/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-01-18T11:02:58-08:00
* @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-06T08:59:32-07:00
*/



import React, { Component } from 'react';
import Checkbox from '../../common/Checkbox';
import Headline from '../../common/Headline';
import Header from '../../blocks/Header';
import InputGroup from '../../blocks/InputGroup';
import Container from '../../blocks/Container';


class Notifications extends Component {
  render() {
    let {settings, updateAccountSetting} = this.props;

    return (
        <div>
          <Header>
            <div>
              <Headline hasDescription>Notifications</Headline>
              <Headline subhead>Use these settings to choose which notifications you will receive.</Headline>
            </div>
          </Header>
          <Container>
            <InputGroup vertical>
              <Checkbox value={settings.notify_matches} id="notify_matches" onChange={updateAccountSetting} label="Email my most recent matches." />
              <Checkbox value={settings.notify_message} id="notify_message" onChange={updateAccountSetting} label="Email me when I receive a new message." />
              <Checkbox value={settings.notify_offer} id="notify_offer" onChange={updateAccountSetting} label="Email me when someone asks to join my trip." />
              <Checkbox value={settings.notify_favorite} id="notify_favorite" onChange={updateAccountSetting} label="Email me when someone favorites me." />
              <Checkbox value={settings.notify_view} id="notify_view" onChange={updateAccountSetting} label="Email me when my profile is viewed." />
            </InputGroup>
          </Container>
        </div>
    );
  }
}

export default Notifications;



// WEBPACK FOOTER //
// ./src/components/pages/Settings/Notifications.jsx